import React from "react";
import Navbar from "../../../components/Navbar/Navbar.component";

const AppHeadings = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default AppHeadings;
